export async function getWeblinkFromApi (webUrl) {
  let apiDocument;
  try {
    apiDocument = await fetch(`copilotWebLink?webLink=${webUrl}`);
  } catch {
    return {};
  }
  return apiDocument.json();
}